// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__14bow","overflowing":"ReadFullNote_overflowing__2Yuua"};